'use client';

import { trackPhoneClick } from '@/lib/analytics';

interface TrackedPhoneLinkProps {
  /** Phone number (with country code, e.g., +18669032097) */
  phoneNumber: string;
  /** Display text */
  displayText?: string;
  /** Source for tracking */
  source: string;
  /** Additional className */
  className?: string;
  /** Children elements (alternative to displayText) */
  children?: React.ReactNode;
}

/**
 * Phone link with GA4 tracking.
 * Use this component to track when users click phone numbers.
 */
export default function TrackedPhoneLink({
  phoneNumber,
  displayText,
  source,
  className = '',
  children,
}: TrackedPhoneLinkProps) {
  const handleClick = () => {
    trackPhoneClick(source, phoneNumber);
  };

  return (
    <a
      href={`tel:${phoneNumber}`}
      onClick={handleClick}
      className={className}
    >
      {children || displayText || phoneNumber}
    </a>
  );
}
